module.exports = __webpack_public_path__ + "img/1530983120.3f21bfe1.jpg";